/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function () {
  // const editHeaderSpaceHeight = () => {
  //   const mainHeaderHeight = document.querySelector('.main_header').offsetHeight;
  //   const mainHeaderSpace = document.querySelector('.main_header_space');
  //   mainHeaderSpace.style.cssText = `--main-header-height: ${mainHeaderHeight}px`;
  // }

  // const mainHeader = document.querySelector('.main_header');
  // const mutationObserver = new MutationObserver((mutationsList, observer) => {
  //   setTimeout(() => {
  //     mutationsList.forEach(mutation => {
  //       if (mutation.attributeName === 'class') {
  //         editHeaderSpaceHeight();
  //       }
  //     })
  //   }, 200);
  // })
  // mutationObserver.observe(mainHeader, { attributes: true })

  document.addEventListener('theme:scroll', e => {
    let scrollPosition = Math.round(window.scrollY);
    const mainHeader = document.querySelector('.main_header');

    if (scrollPosition > 0) {
      if (!mainHeader.classList.contains('is-pinned')) {
        mainHeader.classList.add('is-pinned');
      }
    }
    else {
      if (mainHeader.classList.contains('is-pinned')) {
        mainHeader.classList.remove('is-pinned');
      }
    }
  });

  // window.addEventListener('resize', e => {
  //   editHeaderSpaceHeight();
  // });

  // editHeaderSpaceHeight();

  const setSessionStorageScroll = () => {
    sessionStorage.setItem('scrollPosition', window.scrollY);
  }

  document.querySelectorAll('.collection__filters__wrapper .range__dot--right, .collection__filters__wrapper .range__dot--left')?.forEach(dot => dot.addEventListener('click', () => {
    setSessionStorageScroll();
  }));

  document.querySelectorAll('a.collections-filter__collection')?.forEach(link => {
    link.addEventListener('click', () => {
      setSessionStorageScroll();
    });
  });

  document.querySelectorAll('.collection__filters__wrapper input')?.forEach(input => input.addEventListener('change', () => {
    setSessionStorageScroll();
  }));

  // Preserve the scroll position across page reloads (e.g., after applying filters)
  // if filters are applied

  if (window.location.search.length > 1) {
    document.addEventListener('DOMContentLoaded', () => {
      const scrollY = sessionStorage.getItem('scrollPosition');
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY));
        sessionStorage.removeItem('scrollPosition');
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    const images = document.querySelectorAll('img');
    const windowHeight = window.innerHeight;

    images.forEach(img => {
      const rect = img.getBoundingClientRect().top + window.scrollY;

      if (rect > windowHeight) {
        img.setAttribute('loading', 'lazy');
      }
    });
  });

})();
